// @ts-nocheck
import { isExpired, decodeToken } from "react-jwt";
import sha256 from 'crypto-js/sha256';
import Base64 from 'crypto-js/enc-base64';

export const IsAuthorized = () => {
    return TokenExist() && !!IsValidJwtToken() && !IsTokenExpired();
};

export const TokenExist = () => window.sessionStorage.getItem("accessToken");

export const IsValidJwtToken = () => {
    const accessToken = window.sessionStorage.getItem("accessToken");
    if (!!decodeToken && !!accessToken) {
        return decodeToken(accessToken);
    }

    return false;
};

export const IsTokenExpired = () => {
    const accessToken = window.sessionStorage.getItem("accessToken");
    if (!!accessToken) {
        return isExpired(accessToken);
    }

    return true;
};

export const GenerateCodeVerifier = () => {
    const length = 128;
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
    for (var i = 0; i < length; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return text;
};

export const GetBase64Url = (string: string) => {       
    return string.toString(Base64).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
};

export const GenerateCodeChallenge = (codeVerifier: string) => {
    return GetBase64Url(sha256(codeVerifier));
};

// Funzione per ottenere informazioni dettagliate sul token
export const GetTokenInfo = () => {
    const accessToken = window.sessionStorage.getItem("accessToken");
    if (!accessToken) {
        return null;
    }

    try {
        const decodedToken = decodeToken(accessToken);
        if (decodedToken && typeof decodedToken === 'object') {
            const now = Math.floor(Date.now() / 1000);
            const exp = decodedToken.exp;
            const iat = decodedToken.iat;
            
            if (exp) {
                const expirationDate = new Date(exp * 1000);
                const issuedDate = iat ? new Date(iat * 1000) : null;
                const timeUntilExpiration = exp - now;
                
                return {
                    isExpired: timeUntilExpiration <= 0,
                    expirationDate: expirationDate,
                    issuedDate: issuedDate,
                    timeUntilExpiration: timeUntilExpiration, // in secondi
                    timeUntilExpirationMinutes: Math.floor(timeUntilExpiration / 60),
                    timeUntilExpirationHours: Math.floor(timeUntilExpiration / 3600),
                    tokenData: decodedToken
                };
            }
        }
    } catch (error) {
        console.error('Errore nel decodificare il token:', error);
    }
    
    return null;
};

// Funzioni per gestire il refresh token
export const SaveTokens = (accessToken: string, refreshToken: string, expiresIn: number) => {
    const now = Math.floor(Date.now() / 1000);
    const expirationTime = now + expiresIn;
    
    window.sessionStorage.setItem('accessToken', accessToken);
    window.sessionStorage.setItem('refreshToken', refreshToken);
    window.sessionStorage.setItem('tokenExpiration', expirationTime.toString());
    
    console.log('Tokens saved successfully', { expiresIn, expirationTime });
};

export const GetRefreshToken = () => {
    const refreshToken = window.sessionStorage.getItem('refreshToken'); console.log('Retrieved refresh token:', refreshToken);
    return refreshToken;
};

export const ClearTokens = () => {
    window.sessionStorage.removeItem('accessToken');
    window.sessionStorage.removeItem('refreshToken');
    window.sessionStorage.removeItem('tokenExpiration');
    window.sessionStorage.removeItem('idToken');
    window.sessionStorage.removeItem('accountId');
    window.sessionStorage.removeItem('contactId');
    window.sessionStorage.removeItem('user');
    console.log('All tokens cleared');
};

// Controlla se il token sta per scadere - OTTIMIZZATO per token da 5 minuti
export const IsTokenNearExpiration = (thresholdMinutes: number = 2.5) => {
    const accessToken = window.sessionStorage.getItem("accessToken");
    if (!accessToken) {
        return true;
    }

    const tokenInfo = GetTokenInfo();
    if (!tokenInfo) {
        return true;
    }

    // Se il token è già scaduto
    if (tokenInfo.isExpired) {
        return true;
    }

    // Per token da 5 minuti: default threshold è 2.5 minuti (150 secondi)
    // Questo dà abbastanza tempo per retry in caso di errori
    const thresholdSeconds = thresholdMinutes * 60;
    const shouldRefresh = tokenInfo.timeUntilExpiration <= thresholdSeconds;
    
    // Log per debug con token da 5 minuti
    if (shouldRefresh) {
        const remainingMinutes = Math.floor(tokenInfo.timeUntilExpiration / 60);
        const remainingSeconds = tokenInfo.timeUntilExpiration % 60;
        console.log(`🔔 Token near expiration: ${remainingMinutes}m ${remainingSeconds}s remaining (threshold: ${thresholdMinutes}m)`);
    }
    
    return shouldRefresh;
};